
import { UpgradePackDto } from '../../../dto/upgradepack/upgradepackdto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface UpgradePackRequest extends APIRequest
{
    getUpgradePackRequest(): UpgradePackDto;
}

export class UpgradePackRequestImpl extends APIRequestDtoImpl implements UpgradePackRequest
{
    constructor(private buyToneData: UpgradePackDto)
    {
        super();
    }

    getUpgradePackRequest(): UpgradePackDto
    {
        return this.buyToneData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/tune/upgradepack/upgradepackrequest.tsx